<template>
  <Admin style="background: #f2f2f2;">
    <v-main>
      <v-container fluid>
        <v-card class="rounded-xl tw-min-h-80">
          <v-card-text v-if="!selectedCompany.isDemo">
            <v-breadcrumbs :items="items">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  :to="item.to"
                  :disabled="item.disabled"
                  :exact="true">
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>
            <div class="tw-mx-5 tw-mb-5 tw-flex tw-justify-between tw-items-center">
              <span class="tw-font-bold tw-text-xl tw-text-black tw-tracking-wide">ตั้งค่า อัตราแลกเปลี่ยน</span>
              <div>
                <v-btn
                  dense
                  block
                  color="success"
                  class="py-1"
                  variant="tonal"
                  @click="dialog = true"
                >
                  <v-icon>mdi-plus-circle-outline</v-icon>
                </v-btn>
              </div>
            </div>
            <v-row align="center" justify="center" class="tw-mx-2">
              <v-col cols="12" class="tw-pt-2">
                <ExchangeManagement></ExchangeManagement>
              </v-col>
            </v-row>
          </v-card-text>
          <div v-else class="align-center justify-center" style="height: 200px; display: flex;">
            No Permission
          </div>
        </v-card>
        <!-- modal add -->
        <div class="pa-4 text-center" >
          <v-form @submit.prevent="addExchangeRate" ref="form">
            <v-dialog v-model="dialog"  max-width="480">
              <v-card  prepend-icon="mdi-account"  title="Add Exchange Rate">
                <v-card-title>
                  <h3>เพิ่มอัตราแลกเปลี่ยน</h3>
                </v-card-title>
                <v-card-text>
                    <v-row class="tw-px-4 tw-pt-4">
                      <v-text-field outlined dense label="Currency Code (SAP-Business One)" v-model="currencyCode" :rules="rulesCurrencyCode" required></v-text-field>
                    </v-row>
                    <v-row class="tw-px-4">
                      <v-text-field outlined dense label="Currency Rate" v-model="currencyRate" :rules="rulesCurrencyRate" required></v-text-field>
                    </v-row>
                    <v-row class="tw-px-4 tw-pt-2">
                      <v-select
   :menu-props="{ bottom: true, offsetY: true }"
                        :items="banks"
                        outlined
                        dense
                        v-model="bank"
                        label="Bank"
                        :rules="rulesBank"
                      >
                      </v-select>
                    </v-row>
                    <v-row class="tw-px-4">
                      <v-select
   :menu-props="{ bottom: true, offsetY: true }"
                        :items="fieldType"
                        outlined
                        dense
                        v-model="field"
                        label="Field"
                        :rules="rulesFild"
                      >
                      </v-select>
                    </v-row>
                    <v-row class="tw-px-5 tw-pb-3">
                      <div class="tw-flex tw-flex-col">
                        <label>Active</label>
                        <div class="tw-flex tw-items-center tw-gap-2">
                          <div :class="!isActive ? 'tw-text-red' : 'tw-text-gray'">
                            OFF
                          </div>
                          <div class="tw-flex tw-items-center tw-pb-1.5">
                            <v-switch
                              v-model="isActive"
                              color="teal lighten-2"
                              hide-details
                              class="tw-mt-0"
                            >
                            </v-switch>
                          </div>
                          <div :class="isActive ? 'text-green' : 'tw-text-gray'">
                            ON
                          </div>
                        </div>
                      </div>
                    </v-row>
                    <v-row class="tw-flex tw-justify-between tw-p-4">
                      <v-btn outlined class="me-1" @click="()=>{clearForm();dialog = false}">
                        ปิด
                      </v-btn>
                      <v-btn :disabled="isAdding" color="primary" type="submit" variant="tonal" @click="addExchangeRate" :loading="isAdding">
                        เพิ่ม
                      </v-btn>
                    </v-row>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-form>
        </div>
        <!-- modal add -->
       </v-container>
    </v-main>
    <v-snackbar
      v-model="snackbar"
      top
      :color="snackbarColor"
      timeout="2000"
      class="tw-text-center"
    >
      {{ snackbarText }}
    </v-snackbar>
  </Admin>
</template>

<script>
import Admin from '../../components/admin/admin-main-template'
import ExchangeManagement from '../../components/admin/settings/exchange-management'
import {mapState} from "vuex";
import fc from "@/firebaseConfig";

export default {
  name: 'Settings',
  components: {
    Admin,
    ExchangeManagement
  },
  computed: mapState({
    selectedCompany: state => state.companies.selectedCompany,
    banks: state => state.exchangeRate.bankList.map(bank => bank.code),
  }),
  data: () => ({
    isAdding: false,
    snackbar: false,
    snackbarText: "",
    snackbarColor: "success",
    items: [
      {
        text: 'ตั้งค่า',
        disabled: false,
        to: {name: 'Company.Settings'},
      },
      {
        text: 'อัตราแลกเปลี่ยน',
        disabled: true,
      },
    ],
    dialog: false,
    valid:false,
    currencyCode:'',
    currencyRate:'',
    bank:'',
    field:'',
    fieldType: [],
    isActive: true,
    rulesCurrencyCode:[ (v) => !!v || 'Currency Code Required'],
    rulesCurrencyRate:[(v) => !!v || 'Currency Rate required'],
    rulesBank:[(v) => !!v || 'Bank Required'],
    rulesFild:[ (v) => !!v || 'Field Required']
  }),
  watch: {
    async bank(val) {
      if (val !== '') {
        this.fieldType = await this.$store.dispatch('exchangeRate/getBankFieldListValue', val);
      } else {
        this.fieldType = [];
      }
    }
  },
  methods:{
    async addExchangeRate() {
      this.isAdding = true;
      if (this.$refs.form.validate()) {
        const newExchangeRate = {
          code:this.currencyCode,
          currencyRate: this.currencyRate,
          bank: this.bank,
          field: this.field,
          isActive: this.isActive
        };
        try {
          const companyID = this.$route.params.companyId;
          const docRef = fc.db.collection(`Companies/${companyID}/ExchangeRate`).doc('setting');
          const fieldKey = await this.$store.dispatch('exchangeRate/getFieldByBankAndFieldName', {
            fieldName: newExchangeRate.field,
            bankName: newExchangeRate.bank
          });
          await docRef.set(
            {
              [`currency`]:{
                [newExchangeRate.code]:{
                  bank: newExchangeRate.bank,
                  currencyRate: newExchangeRate.currencyRate,
                  field: fieldKey,
                  fieldName: newExchangeRate.field,
                  isActive: newExchangeRate.isActive
                }
              }
            },
            { merge: true }
          );
          this.snackbarText = "เพิ่มอัตราแลกเปลี่ยนสำเร็จ";
          this.snackbarColor = "success";
          this.snackbar = true;
          this.clearForm();
          this.dialog = false;

        } catch (error) {
          console.error("Error adding exchange rate: ", error);
          this.snackbarText = "เพิ่มอัตราแลกเปลี่ยนไม่สำเร็จ";
          this.snackbarColor = "error";
          this.snackbar = true;
        } finally {
          this.isAdding = false;
        }
        }
    },
    clearForm() {
      this.currencyCode = '';
      this.currencyRate = '';
      this.bank = '';
      this.field = '';
      this.isActive = true;
    },
  },
}
</script>
<style lang="scss">
.row-wrapper{
  padding-left: 20px;
}
</style>
